export default __webpack_public_path__ + "static/media/add-from-blade-icon.42c6e5fd.svg";